import React, { FC, useRef } from 'react';

import { Button } from 'devextreme-react/button';
import DataGrid, {
  Column,
  Editing,
  FilterRow,
  Form,
  Pager,
  Paging,
  Popup,
  RequiredRule,
} from 'devextreme-react/data-grid';
import { Item } from 'devextreme-react/form';
import 'devextreme-react/text-area';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import { useAuth } from 'context/auth';
import CustomStore from 'devextreme/data/custom_store';
import { requestHelper } from 'utils/request-helper';

const UnitPage: FC = () => {
  const unitDataStore: any = new CustomStore({
    key: 'id',
    load: (loadOptions: any) => requestHelper('/v1/Unit', 'get', loadOptions),
    insert: async (values) => {
      await requestHelper('/v1/Unit', 'post', {
        values: values,
      });
    },

    remove: async (key) =>
      await requestHelper(`/v1/Unit/${key}`, 'delete', {
        key: key,
      }),

    update: async (key, values) =>
      await requestHelper(`/v1/Unit/${key}`, 'put', {
        key: key,
        values: values,
      }),
  });

  const refGrid = useRef<DataGrid | null>(null);
  const { getClaims }: any = useAuth();

  return (
    <div className="container-dev">
      <AppLayoutTop title="Ед. изм.">
        <ClaimsProvider claimsBlock={['CanEditUnit']}>
          <Button width={120} text="Создать" type="default" onClick={() => refGrid.current?.instance.addRow()} />
        </ClaimsProvider>
      </AppLayoutTop>

      <AppCard>
        <DataGrid
          dataSource={unitDataStore}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
          onRowUpdating={(e) => (e.newData = { ...e.oldData, ...e.newData })}
          onInitNewRow={(e) => (e.data = { name: '' /* isDeleted: false */ })}
        >
          <FilterRow visible={true} />
          <Editing
            mode="popup"
            allowUpdating={getClaims(['CanEditUnit'])}
            texts={{
              editRow: 'Просмотр',
            }}
            allowDeleting={getClaims(['CanDeleteUnit'])}
          >
            <Popup title="Просмотр информации" showTitle={true} width={400} height="auto" />
            <Form>
              <Item itemType="group" colCount={2} colSpan={2}>
                <Item dataField="name" caption="Наименование" colSpan={2}>
                  <RequiredRule message="Заполните поле Наименование" />
                </Item>
                <Item dataField="comment" caption="Комментарий" colSpan={2} editorType="dxTextArea"></Item>
              </Item>
            </Form>
          </Editing>

          <Column dataField="name" caption="Наименование" sortOrder="asc" />
          <Column dataField="comment" caption="Комментарий" width={200} visible={false} />

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default UnitPage;
